import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export function createOtpBlockStore(storageName) {
  return create(
    persist(
      (set) => ({
        blockExpiresAt: null,
        blockReason: null,
        setOtpBlock: (blockExpiresAt, blockReason = null) =>
          set({ blockExpiresAt, blockReason }),
        clearOtpBlock: () => set({ blockExpiresAt: null, blockReason: null }),
      }),
      {
        name: storageName,
        storage: createJSONStorage(() => localStorage),
        onRehydrateStorage: () => (state) => {
          if (state?.blockExpiresAt && state.blockExpiresAt <= Date.now()) {
            state.clearOtpBlock();
          }
        },
      },
    ),
  );
}

export const useLipaBidhaaOtpBlockStore =
  createOtpBlockStore("lipa-bidhaa-block");

export const useFundsTransferOtpBlockStore = createOtpBlockStore(
  "funds-transfer-block",
);

// unlike the transaction OTP blocks above,
// backend gives us an exact retryAvailableAt, so callers should convert that
// directly to an epoch ms timestamp rather than deriving one.
export const usePinLoginBlockStore = createOtpBlockStore("pin-login-block");

// shared across all PIN-authorized flows (FundsTransfer, LipaBidhaa, ...):
// the transaction PIN is one account-wide PIN, so a lockout in one module
// must block the others too. OTP blocks stay per-module (see stores above).
export const usePinLockedStore = createOtpBlockStore("pin-locked-block");
